import React, { useEffect, useState } from 'react';
import { Icon } from '@kontentino/ui';
import { faMusic } from '@fortawesome/pro-regular-svg-icons/faMusic';
import clsx from 'clsx';

interface InstagramAudioArtworkProps {
  src: string | null;
  alt?: string;
  size?: 'sm' | 'md';
  className?: string;
}

const InstagramAudioArtwork = ({
  src,
  alt,
  size = 'sm',
  className,
}: InstagramAudioArtworkProps) => {
  const [hasFailed, setHasFailed] = useState(false);

  useEffect(() => setHasFailed(false), [src]);

  const wrapperClassName = clsx(
    'tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-md tw-bg-grayscale-10',
    {
      'tw-h-10 tw-w-10': size === 'sm',
      'tw-h-12 tw-w-12': size === 'md',
    },
    className,
  );

  if (!src || hasFailed) {
    return (
      <div className={wrapperClassName}>
        <Icon
          icon={faMusic}
          className="tw-text-grayscale-100"
          size={size === 'md' ? 'md' : 'sm'}
        />
      </div>
    );
  }

  return (
    <div className={wrapperClassName}>
      <img
        src={src}
        alt={alt ?? ''}
        loading="lazy"
        className="tw-h-full tw-w-full tw-object-cover"
        onError={() => setHasFailed(true)}
      />
    </div>
  );
};

export default InstagramAudioArtwork;
